import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'app-chip',
	standalone: true,
	imports: [MatIconModule],
	templateUrl: './chip.component.html',
	styleUrl: './chip.component.scss',
})
export class ChipComponent {
	@Input() labelInput!: string;
	@Input() disabled?: boolean = false;
	@Input() style?: any;

	@Input() onDelete?: any;
	handleDelete(event: MouseEvent) {
		if (this.onDelete) {
			this.onDelete(event);
		}
	}
}
